import Modals from "components/Modal";
import TableTwo from "components/TableTwo";
import useOneOffReport from "hook/reports/useOneOffReport";
import { ONE_OFF_ANALYTICS } from "navigation/routes";
import { Link } from "react-router-dom";
import { startCase } from 'lodash'
import { formatMoney } from "utils/functions";

const OneOffReport = () => {
  const { currentData, setCurrentData, open, setOpen, updateMyData, skipPageReset, columns, data, setData,
    current, edit, setEdit, isLoading, setDateFrom, setDateTo, totalAmount } = useOneOffReport()

  return (
    <>
      <div className="container-fluid px-4">
        <div className="d-sm-flex align-items-start justify-content-between mt-4">
          <div>
            <h1>One Off Donation Report</h1>
            <ol className="breadcrumb mb-2">
              <li className="breadcrumb-item">One Off Donations</li>
              <li className="breadcrumb-item active">All</li>
            </ol>
          </div>
          <Link className="btn btn-primary mb-2" to={`../${ONE_OFF_ANALYTICS}`} relative="path">View Analytics</Link>
        </div>
        <div className="card mb-4">
          <div className="card-header">
            <i className="fas fa-table me-1"></i>
            One Off Donations
          </div>
          <div className="row px-3 pt-3 pb-2 g-2">
            <div className="col-12 col-md-4">
              <div className="d-flex align-items-end gap-2">
                <div className="form-inline flex-fill">
                  <label className="form-label mb-1 small">Date From</label>
                  <input type='date' className="form-control" onChange={(e) => setDateFrom(e.target.value)} />
                </div>
                <div className="form-inline flex-fill">
                  <label className="form-label mb-1 small">To</label>
                  <input type='date' className="form-control" onChange={(e) => setDateTo(e.target.value)} />
                </div>
              </div>
            </div>
          </div>

          <div className="px-3 pb-2">
            <div className="alert alert-info d-inline-block py-2 px-3 mb-0">
              <strong>Total Amount:</strong> {formatMoney(totalAmount)}
            </div>
          </div>

          <div className="card-body">
            <TableTwo
              columns={columns}
              data={data || []}
              setData={setData}
              skipPageReset={skipPageReset}
              filterTable={data?.length}
              isLoading={isLoading}
              fileName='one-off-reports'
            />
          </div>
        </div>
      </div>
      <Modals show={open && current === 'view'}
        onHide={() => setOpen(false)} title='View Donation' size='md'>
        <dl className="striped">
          {currentData && Object.entries(currentData)?.map(([key, value]) =>
            typeof value !== 'string' && typeof value !== 'number' ? [] :
              <div key={key} className='row'>
                <dt className='col-4'>{`${startCase(key)} :`}</dt>
                {(!edit || key === 'id') && <dd className='col-8'>{value}</dd>}
                {edit && key !== 'id' && <div className="col-8"><input className="form-control" type="text" defaultValue={value} onChange={(e) => setCurrentData({ ...currentData, [key]: e.target.value })} /></div>}
              </div>
          )}
        </dl>
      </Modals>
    </>
  )
}

export default OneOffReport
